import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronUp } from 'react-feather';
import * as Unicons from '@iconscout/react-unicons';
import styles from './styles.module.scss';
import { MenuList, MenuListItem } from '../../../types/menu';
import { MdGames } from 'react-icons/md';
import useLocalStorage from '../../../hooks/useUserData';

interface MenuItemProps {
  item: MenuList;
}

const MenuItem: React.FC<MenuItemProps> = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);

  const currentActivePathname = useMemo(() => {
    return (url: string) => {
      const arrayCurrentPathname = window.location.pathname.split('/');
      if (arrayCurrentPathname.length > 3) {
        const getMainPathname = window.location.pathname
          .split('/')
          .slice(0, 3)
          .join('/');
        return getMainPathname === url;
      } else {
        return window.location.pathname === url;
      }
    };
  }, []);

  const activeMenuParent = useCallback((item: any) => {
    if (item.children) {
      return item.children.some((child: any) =>
        currentActivePathname(child.url)
      );
    }

    return currentActivePathname(item.url);
  }, []);

  useEffect(() => {
    if (activeMenuParent(item)) {
      setIsOpen(true);
    }
  }, [activeMenuParent]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleClickMenu = (item: any) => {
    if (item.children) {
      handleToggle();
      return;
    }
  };

  const renderIcons = (name: string, active: boolean) => {
    const color = active ? 'rgba(123, 33, 131, 1)' : 'rgba(153, 153, 153, 1)';
    switch (name) {
      case 'Home Page':
        return <Unicons.UilTachometerFast size="24" color={color} />;
      case 'My Learning':
        return <Unicons.UilSwatchbook size="24" color={color} />;
      case 'About BCL&D':
        return <Unicons.UilUsersAlt size="24" color={color} />;
      case 'Staff Directory':
        return <Unicons.UilFileBookmarkAlt size="24" color={color} />;
      case 'Back Office BCL&D':
        return <Unicons.UilFileCopyAlt size="24" color={color} />;
      case 'RATER':
        return <Unicons.UilFileEditAlt size="24" color={color} />;
      case 'Reward and Gamification':
        return <MdGames size="24" color={color} />;
      case 'Guide':
        return <Unicons.UilFileBookmarkAlt size="24" color={color} />;
      case 'BCL&D Calendar':
        return <Unicons.UilCalendarAlt size="24" color={color} />;
      case 'My Profile':
        return <Unicons.UilUserCircle size="24" color={color} />;
      case 'Dashboard BCL&D':
        return <Unicons.UilDashboard size="24" color={color} />;
      case 'Team Learning':
        return <Unicons.UilUserSquare size="24" color={color} />;
      case 'Failure & Success Moments':
        return <Unicons.UilMedal size="24" color={color} />;
      default:
        return;
    }
  };

  return (
    <div>
      {item.children ? (
        <div
          className={`${styles['menu-item-container']}  ${
            activeMenuParent(item) ? styles.active : ''
          }`}
          onClick={() => {
            if (item.name === 'Failure & Success Moments') {
              window.location.href = '/snfm/overview';
              return;
            }
            handleClickMenu(item);
          }}
        >
          <div className={styles['menu-item-container__menu-item']}>
            {renderIcons(item.name, activeMenuParent(item))}
            <p className="m-0">{item.name}</p>
          </div>
          {isOpen ? (
            <ChevronUp
              className={
                activeMenuParent(item) ? 'text-primary-60' : 'text-grey-70'
              }
            />
          ) : (
            <ChevronDown
              className={
                activeMenuParent(item) ? 'text-primary-60' : 'text-grey-70'
              }
            />
          )}
        </div>
      ) : (
        <Link
          className={`${styles['menu-item-container']}  ${
            window.location.pathname === item.url ? styles.active : ''
          }`}
          to={item.url}
        >
          <div className={styles['menu-item-container__menu-item']}>
            {renderIcons(item.name, window.location.pathname === item.url)}
            <p className="m-0">{item.name}</p>
          </div>
        </Link>
      )}
      {isOpen && item.children && (
        <ul className={styles['menu-container-children']}>
          {item.children.map((child, index) => (
            <Link
              to={child.url}
              className={currentActivePathname(child.url) ? styles.active : ''}
              key={index}
            >
              <span>{child.name}</span>
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MenuItem;
